import { IInitialState } from 'src/store/initialState';

const allAccountViewSelector = (
  state: IInitialState
): IInitialState['accountView'] => state.accountView;

export const accountViewMenuOptionSel = (state: IInitialState) =>
  allAccountViewSelector(state).menuOption;
export const accountViewIsPendingSel = (state: any) =>
  allAccountViewSelector(state).isPending;
export const accountViewErrorSel = (state: any) =>
  allAccountViewSelector(state).error;
export const accountCurrentPasswordSel = (state: any) =>
  allAccountViewSelector(state).currentPassword;
export const accountNewPasswordSel = (state: any) =>
  allAccountViewSelector(state).newPassword;
export const accountNewPasswordRepeatSel = (state: any) =>
  allAccountViewSelector(state).newPasswordRepeat;
export const accountNewPasswordValidationSel = (state: any) =>
  allAccountViewSelector(state).newPasswordValidation;
export const accountAddressRequestSel = (state: any) =>
  allAccountViewSelector(state).addressRequest;
export const deliveryStateSel = (state: any) =>
  allAccountViewSelector(state).deliveryStatus;
export const creditCardSel = (state: any) =>
  allAccountViewSelector(state).creditCardStatus;
